import React from 'react';
import { i18n } from 'utils/i18n';
import Modal from 'components/Modal';
import MODAL, { MODAL_THEMES } from 'constants/modals';
import RemovePartnerRewardsModalContent from 'components/ReservationFlow/SharedModals/RemovePartnerRewardsModalContent';

const RemovePartnerRewardsModal = () => (
  <Modal
    modalKey={MODAL.REMOVE_PARTNER_REWARDS_MODAL}
    header={i18n('progress_bar_partner_rewards_modal_header')}
    theme={MODAL_THEMES.WHITE}
  >
    <RemovePartnerRewardsModalContent describedByID={`${MODAL.REMOVE_PARTNER_REWARDS_MODAL}_desc`} />
  </Modal>
);

export default RemovePartnerRewardsModal;
